import {
  ROOF_TOP_MANAGEMENT_SET_MY_ROOF_TOP,
  ROOF_TOP_MANAGEMENT_SET_ROOF_TOPS,
  RoofTopManagementAction,
} from './roofTopManagementActionTypes';
import { RoofTopManagementState } from './roofTopManagementTypes';

const initialState: RoofTopManagementState = {
  roofTops: [],
  myRoofTop: undefined,
  roofTop: undefined,
};

export const ROOF_TOP_MANAGEMENT_NAMESPACE = 'ROOF_TOP_MANAGEMENT_NAMESPACE';

function roofTopManagementReducer(
  state = initialState,
  action: RoofTopManagementAction
): RoofTopManagementState {
  switch (action.type) {
    case ROOF_TOP_MANAGEMENT_SET_ROOF_TOPS:
      return { ...state, roofTops: action.payload };
    case ROOF_TOP_MANAGEMENT_SET_MY_ROOF_TOP:
      return { ...state, myRoofTop: action.payload };
    default:
      return state;
  }
}

export default roofTopManagementReducer;
